const contents = {
  HEADER: {
    MENU: {
      SEARCH: "BUSCAR",
      ABOUT_US: "SOBRE NOSOTROS",
      OPINION: "OPINIÓN",
      SIGN_IN: "ACCESO EMPRESA",
      MANUAL: "MANUAL"
    }
  },
  FOOTER: {
    MENU: {
      PRIVACY_POLICY: "POLÍTICA DE PRIVACIDAD",
      TERMS_OF_SERVICE: "TERMINOS LEGALES",
      COOKIE_POLICY: "POLÍTICA DE COOKIES"
    }
  },
  HOME: {
    TITLE: "Programa de inocuidad alimentaria",
    SUBTITLE: "Encuentra este distintivo en tus establecimientos de confianza",
    VIDEO: "Haz click aquí para ver video"
  },
  SEARCH: {
    TITLE: "BUSCAR",
    CONTENT:
      "¿Vas a comer fuera? Conoce si el restaurante, hotel o catering tiene buena higiene y sigue los estándares de calidad marcados por el Control Oficial.",
    FILTERS: {
      NAME: "Nombre",
      ADDRESS: "Dirección",
      SCORE: "Puntuación"
    },
    RESULTS: {
      MORE_INFO: "MÁS INFO",
      VIEW_MORE: "VER MÁS"
    }
  },
  ABOUT_US: {
    TITLE: "Sobre nosotros",
    CONTENT: {
      P1:
        "SALUD PÚBLICA es el área de la Conselleria de Salut del Govern de les Illes Balears que se encarga de velar y promover la inocuidad alimentaria.",
      P2:
        "El PROGRAMA QxQ es el resultado de la investigación y consenso técnico para empoderar a las empresas de la cadena alimentaria y hacer transparente sus procesos de higiene y facilitar la elección de los consumidores."
    },
    Q1: {
      TITLE: "Q de Cuantificación",
      CONTENT:
        "Hace referencia a la verificación del autocontrol que realizan las empresas alimentarias, con una puntuación que va de 1 (muy desfavorable) a 5 (excelente), que será consensuada por técnicos validadores externos y de Salud Pública."
    },
    Q2: {
      TITLE: "Q de Cualificación",
      CONTENT:
        "Hace referencia al hecho que las empresas y los consumidores, residentes y visitantes, puedan comentar y cualificar la estrategia del Programa QxQ para una mejora contínua de la inocuidad alimentaria en les Illes Balears."
    }
  },
  OPINION: {
    TITLE: "Tu opinión",
    CONTENT:
      "¿Cómo ves esta puntuación? ¿Tienes sugerencias sobre el proyecto?. Mándanos un mensaje con tus comentarios y ayúdanos a mejorar!",
    FORM: {
      NAME: "Nombre",
      EMAIL: "Email",
      MESSAGE: "Mensaje",
      SUBMIT: "ENVIAR"
    },
    FEEDBACK: "¡Gracias por compartir tu opinión con nosotros!"
  },
  FACILITY: {
    RELATED: "También te pueden interesar:",
    ADDRESS: "Dirección",
    CONTACT: "Contacto",
    EXPLAINATION:
      "* La puntuación valora la última verificación del autocontrol hecha por el establecimiento y consensuada por los técnicos con la diligencia debida. En todo caso, la empresa que gestiona el establecimiento es la responsable de garantizar el cumplimento de todos los requisitos de higiene alimentaria."
  },
  BLOCK: {
    FIRST: {
      1: "Las infraestructuras y equipamientos de este establecimiento no son adecuadas para las actividades que se desarrollan. Su mantenimiento y limpieza es insuficiente y el uso que se les da no permite garantizar la seguridad alimentaria de los productos que elaboran.",
      2: "Las infraestructuras y equipamientos de este establecimiento deben actualizarse y su nivel de mantenimiento y limpieza deben mejorar para evitar riesgos en la seguridad alimentaria de los productos que se elaboran.",
      3: "Las infraestructuras y equipamientos de este establecimiento permiten unas condiciones aceptables para la elaboración de alimentos. Existe un margen de mejora en algunos aspectos.",
      4: "Las infraestructuras y equipamientos de este establecimiento permiten unas condiciones adecuadas para la elaboración de alimentos. Están en un buen estado de mantenimiento y limpieza y su uso es correcto.",
      5: "Las infraestructuras y equipamientos de este establecimiento son las adecuadas para la elaboración de alimentos. Están en un muy buen estado de mantenimiento y limpieza y su uso es óptimo."
    },
    SECOND: {
      1: "Las prácticas de elaboración y manipulación no permiten preparar alimentos seguros para el consumidor. Los manipuladores de alimentos no están formados.",
      2: "Deben mejorarse las prácticas de elaboración y manipulación para poder preparar alimentos seguros para el consumidor. Debe mejorar la formación de los manipuladores de alimentos.",
      3: "Las prácticas de elaboración y manipulación de alimentos permiten preparar la comida de manera aceptable. No obstante, existen puntos de mejora importantes que deben corregirse.",
      4: "Las prácticas de elaboración y manipulación de alimentos son adecuadas. Las medidas de control de riesgos son suficientes y la formación de los manipuladores es correcta.",
      5: "Las prácticas de elaboración y manipulación de alimentos son muy buenas. Las medidas de control de riesgos son óptimas y los manipuladores están debidamente formados."
    },
    THIRD: {
      1: "Los planes y registros de autocontrol no se corresponden con la realidad, no abarcan todas las actividades del establecimiento y no están debidamente cumplimentados, no permiten hacer un seguimiento de las actividades que se están desarrollando ni confiar en sus procedimientos de gestión.",
      2: "Algunos de los planes y registros de autocontrol no se corresponden con la realidad, no abarcan todas las actividades del establecimiento o no están debidamente cumplimentados. No permiten hacer un buen seguimiento de las actividades que se están desarrollando ni confiar en la gestión de las mismas.",
      3: "En general, los planes y registros de autocontrol se corresponden con la realidad, abarcan todas las actividades del establecimiento y están debidamente cumplimentados, permitiendo hacer un seguimiento de las actividades que se están desarrollando. Existen aspectos en los que los planes o los registros pueden mejorar.",
      4: "Los planes y registros de autocontrol se corresponden con la realidad, abarcan todas las actividades del establecimiento y están debidamente cumplimentados, permitiendo hacer un seguimiento de las actividades que se están desarrollando.",
      5: "Los planes y registros de autocontrol se corresponden con la realidad, abarcan todas las actividades del establecimiento y están debidamente cumplimentados, permitiendo un seguimiento óptimo de las actividades que se están desarrollando y una elevada confianza en sus procedimientos de gestión."
    }
  },
  SCORES: {
    5: "EXCELENTE",
    4: "BUENO",
    3: "REGULAR",
    2: "DEFICIENTE",
    1: "MUY\nDEFICIENTE"
  },
  UPDATED: "ACTUALIZADO"
};

export default contents;



// WEBPACK FOOTER //
// ./src/services/translation/contents.es_ES.js